import { useEffect } from "react";

// Global mobile UX helper: when any input/textarea/select gains focus, smoothly
// scroll it into the vertical center so the on-screen keyboard never overlays the
// active field. Mounted once at the app root — covers every form globally.
export function useMobileFocusScroll() {
  useEffect(() => {
    const FOCUSABLE = ["INPUT", "TEXTAREA", "SELECT"];
    const handler = (e) => {
      const el = e.target;
      if (!el || !FOCUSABLE.includes(el.tagName)) return;
      const t = el.type;
      if (t === "checkbox" || t === "radio" || t === "button" || t === "submit" || t === "hidden") return;
      // Delay so the virtual keyboard has begun to open before we recenter.
      window.setTimeout(() => {
        try {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        } catch {
          el.scrollIntoView();
        }
      }, 300);
    };
    document.addEventListener("focusin", handler);
    return () => document.removeEventListener("focusin", handler);
  }, []);
}
